import React, { createContext, useContext, useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Outlet, useLocation } from 'react-router-dom';
import { BsBoxArrowLeft } from "react-icons/bs";
import { ContextNotification, severitys } from '../../App';
import PrivateRoutList from '../../Router/PrivateRoutList';
import logo from "../../assets/logo.png"
import UserApi from '../../api/UserApi';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { MdClose, MdMenu } from 'react-icons/md';
import { Grid2, IconButton, Paper, Tooltip } from '@mui/material';

import styled from 'styled-components';
import RtlProvider from '../../Components/RtlProvider';
import enumMapper from '../../enumMapper';
import themes from '../../themes';
import VerticalMenu from '../../Layout/Admin/VerticalMenu';

export const ContextMenues = createContext();
export const ContextUserInfo = createContext();

const exitToApp = () => {
  localStorage.clear();
  window.location.pathname = "/login";
}
const drawerWidth = 240;
export default function MainPanel() {
  const appid = enumMapper.AppId.GuestService;
  const [hasAccess, setHasAccess] = React.useState(false)
  const [menues, setMenues] = React.useState([]);
  const [refresh, setRefresh] = useState(false);
  const location = useLocation();
  const [userInfo, setUserInfo] = React.useState(null);
  const [userRoles, setUserRoles] = React.useState([]);
  const [userPermissions, setUserPermissions] = React.useState(null);
  const { setOpen } = useContext(ContextNotification);

  React.useEffect(() => {
    GetMenues();
    GetPermissions();
    setHasAccess(CheckAccess());
  }, [location]);

  React.useEffect(() => {
    setHasAccess(CheckAccess());
  }, [refresh]);

  const GetMenues = () => {
    return UserApi.GetMenuItems(appid)
      .then((data) => {
        setMenues(data.data);
      })
      .catch(err => {
        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }
        exitToApp();
      }
      );
  };

  const GetPermissions = () => {
    return (
      UserApi.GetPermissions(appid)
        .then(async (data) => {
          setUserInfo(data.data.user)
          setUserPermissions(data.data.permisions);
          setUserRoles(data.data.roles)
          setRefresh(old => !old);
        })
        .catch(err => {
          if (err.response && err.response.data) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
          }
          else if (err.response && err.response.data && err.response.data.errors) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
          }
          else if (err.message) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
          }
        }
        )
    );
  };
  function CheckAccess() {
    var res = false;
    var prout = null;
    var pathparts = location.pathname.trim().trimEnd('/').toLowerCase().split('/');
    if ((pathparts.length >= 2) && (pathparts[1] === 'dashboard')) {
      if (pathparts.length === 2)
        return true;
      else {
        prout = PrivateRoutList.find(e => (e.name.toLowerCase() === (pathparts[2] + ':' + pathparts[3])));
        if (prout)
          res = userPermissions?.some(p => (p.claimType.toLowerCase() === pathparts[2]) && (p.claimValue.toLowerCase() === pathparts[3]))
        else {
          prout = PrivateRoutList.find(e => (e.path.toLowerCase()) === (pathparts.length === 3 ? pathparts[2] : pathparts[2] + '/' + pathparts[3]))
          if (prout) {
            res = menues?.some(pmenu =>
              prout.name === pmenu.menuName)
            if (!res)
              res = menues?.map(mnu => mnu.children.some(pmenu =>
                prout.name === pmenu.menuName) ? 1 : 0).includes(1)
          }
        }
      }
    }
    return res
  };

  const getUserName = () => {
    var res = '';
    if (userInfo)
      res = userInfo.firstName + ' ' + userInfo.lastName;
    return res;
  }


  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
        <ContextMenues.Provider value={{ menues, setMenues }}>
          <Box
            sx={{
              pt: "12px",
            }}
          >
            <VerticalMenu menuData={menues} />
          </Box>
        </ContextMenues.Provider>
    </div>
  );
  const mobileDrawer = (
    <div>
      <Toolbar>
        <IconButton onClick={handleDrawerToggle}
        >
          <MdClose />
        </IconButton>
      </Toolbar>
      <Divider />
    
        <ContextMenues.Provider value={{ menues, setMenues }}>
          <VerticalMenu menuData={menues} />
        </ContextMenues.Provider>
      
    </div>
  );

  const isStepperPage = location.pathname.toLowerCase().startsWith('/Dashboard/GuestRequest/Add'.toLowerCase());
  return (
    <RtlProvider>
      <ThemeProvider theme={themes.defaultTheme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />

          <AppBar
            color="primary"
            position="fixed"
            sx={{
              bgcolor: 'primary.main',
              zIndex: (theme) => theme.zIndex.drawer + 1
            }}
          >
            <Toolbar
              disableGutters
              sx={{
                minHeight: { xs: 64, sm: 72 },
                px: 0
              }}
            >

              <Box sx={{ width: '100%' }}>

                {/* ردیف بالا در موبایل */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="h6"
                      component="h1"
                      sx={{
                        display: { xs: 'block', sm: 'none' },
                        fontFamily: 'BFarnaz',
                        fontSize: { xs: '1rem', md: '2rem' }
                      }}
                    >
                      سامانه ثبت درخواست سفر عمره
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                      aria-label="open drawer"
                      onClick={handleDrawerToggle}
                      sx={(theme) => ({ display: { sm: 'none' }, color: theme.palette.custom.neutralMain })}
                    >
                      <MdMenu />
                    </IconButton>
                  </Box>
                </Box>

                {/* ردیف اصلی */}
                <Box sx={{ display: 'flex' }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {/* لوگو اصلاح شده */}
                      <Box
                        component="img"
                        src={logo}
                        alt="موسسه عمره سعادت"
                        sx={{
                          height: { xs: 64, sm: 72 },
                          width: 'auto',
                          objectFit: 'contain',
                          display: 'block'
                        }}
                      />
                      <Typography
                        variant="h6"
                        component="h1"
                        sx={{
                          display: { xs: 'none', sm: 'block' },
                          fontFamily: 'BFarnaz',
                          fontSize: { xs: '1rem', md: '2rem' }
                        }}
                      >
                        سامانه ثبت درخواست سفر عمره
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ ml: 1 }}>
                      {getUserName()}
                    </Typography>

                    <Tooltip title="خروج از سامانه" placement="right">
                      <IconButton
                        onClick={exitToApp}
                        sx={{ color: '#cecdce' }}
                      >
                        <BsBoxArrowLeft />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>

              </Box>
            </Toolbar>
          </AppBar>

          {/* Drawer Section */}
          <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
          >
            <Drawer
              variant="temporary"
              open={mobileOpen}
              onTransitionEnd={handleDrawerTransitionEnd}
              onClose={handleDrawerClose}
              ModalProps={{ keepMounted: true }}
              sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: drawerWidth,
                  boxSizing: 'border-box'
                }
              }}
              
            >
              {mobileDrawer}
            </Drawer>

            <Drawer
              variant="permanent"
              sx={{
                display: { xs: 'none', sm: 'block' },
                '& .MuiDrawer-paper': {
                  boxSizing: 'border-box',
                  width: drawerWidth
                }
              }}
              
              open
            >
              {drawer}
            </Drawer>
          </Box>

          {/* Main Content */}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              height: isStepperPage ? '100%' : 'auto',
              overflow: isStepperPage ? 'visible' : 'auto',
              p: 3,
              pt: { xs: 10, sm: 3 }
            }}
          >
            <Toolbar />
            {hasAccess && (
              <ContextUserInfo.Provider
                value={{ userInfo, userPermissions, userRoles }}
              >
                <Outlet />
              </ContextUserInfo.Provider>
            )}
          </Box>

        </Box>

      </ThemeProvider>
    </RtlProvider>
  );
}
